import {isValid} from 'date-fns';
import {translations} from 'presentation/translations-new';
import {parseDate} from 'presentation/utils';
import {z} from 'zod';

const {dateError, endDateError, invalidDate, onlyNumbers} =
	translations['pt-br'].privateFlow.consultRefund;
const {requiredField} = translations['pt-br'].commons;

const refundByProtocolSchema = z.object({
	protocolNumber: z.string().regex(/^\d*$/, {message: onlyNumbers}),
});

const refundByDateSchema = z
	.object({
		rangeDate: z.string(),
	})
	.superRefine((data, context) => {
		const [initialDateString, endDateString] = data.rangeDate.split(' - ');
		const initialDate = parseDate(initialDateString);
		const endDate = parseDate(endDateString);

		if (initialDate && endDate && (!isValid(initialDate) || !isValid(endDate))) {
			context.addIssue({
				code: z.ZodIssueCode.custom,
				path: ['rangeDate'],
				message: invalidDate,
			});
		}

		if ((initialDate && !endDate) || (!initialDate && endDate)) {
			if (!initialDate) {
				context.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['rangeDate'],
					message: requiredField,
				});
			}
			if (!endDate) {
				context.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['rangeDate'],
					message: endDateError,
				});
			}
		}

		if (initialDate && endDate && initialDate > endDate) {
			context.addIssue({
				code: z.ZodIssueCode.custom,
				path: ['rangeDate'],
				message: dateError,
			});
		}
	});

export type RefundByDateSchema = z.infer<typeof refundByDateSchema>;
export type RefundByProtocolSchema = z.infer<typeof refundByProtocolSchema>;

export {refundByProtocolSchema, refundByDateSchema};
